/** Gameplay constants shared by pure simulation (sim-time only). */

export const SIM_HZ = 60;
export const SIM_DT = 1 / SIM_HZ;

export const ALTITUDE_FLOOR_M = 3;
/** Stable terrain-relative clearance for the planar skimmer. Not a player control. */
export const PLAYER_HOVER_HEIGHT_M = 9;
export const BASE_SPEED_MPS = 38;
export const BOOST_MULTIPLIER = 1.75;
export const DRIFT_DAMPING = 2.8;
export const TURN_RATE_RAD_PS = 7.5;

export const PLAYER_RADIUS_M = 1.4;
export const PLAYER_BASE_HULL = 100;
export const PLAYER_BASE_SHIELD = 60;
export const SHIELD_REGEN_PER_S = 4;
export const SHIELD_REGEN_DELAY_S = 2.5;

export const EXTRACT_RADIUS_M = 18;
export const EXTRACT_HOLD_S = 2.5;
export const CARRIER_RADIUS_M = 22;

export const CHUNK_SIZE_M = 96;
export const REGION_RADIUS_CHUNKS = 6;
export const ACTIVE_CHUNK_RADIUS = 2;

/** Soft-lock aim cone half-angle (~20°). */
export const AIM_LOCK_HALF_ANGLE_RAD = 0.35;

/** Starting threat budget before time/biome/level scaling. */
export const DIRECTOR_BASE_BUDGET = 4;
/** Soft early-run simultaneous hostile cap (scales up with time/level). */
export const DIRECTOR_MAX_ACTIVE = 6;
export const DIRECTOR_MAX_ACTIVE_CAP = 16;
export const DIRECTOR_SPAWN_COOLDOWN_S = 4.5;
export const DIRECTOR_SPAWN_COOLDOWN_MIN_S = 2.0;
/** No director spawns for this long after expedition start. */
export const DIRECTOR_GRACE_S = 8;
/** First N seconds: slower fire, wider aim scatter, friendlier telegraphs. */
export const DIRECTOR_EARLY_WINDOW_S = 90;
export const DIRECTOR_BLIND_SPOT_DEG = 55;
export const DIRECTOR_LEVEL_THREAT_PER_LEVEL = 0.05;
export const DIRECTOR_ELITE_CHANCE_PER_LEVEL = 0.005;
export const ENEMY_TIER_INTERVAL = 3;
export const TURRET_TELEGRAPH_S = 0.55;
export const TURRET_TELEGRAPH_EARLY_S = 0.9;
/** Seconds between queued staggered spawns (incursions / dumps). */
export const DIRECTOR_SPAWN_STAGGER_S = 1.35;
export const JAMMER_RADIUS_M = 25;
export const JAMMER_REGEN_MULT = 0.5;
export const PICKUP_RADIUS_M = 3.2;
export const AFFIX_DROP_CHANCE = 0.12;

export const PLANET_RADIUS_M = 50_000;

/** In-run pilot progression (resets each expedition). */
export const XP_LEVEL_BASE = 40;
export const XP_LEVEL_EXPONENT = 1.55;
export const XP_LEVEL_LINEAR = 15;
export const MAX_RUN_LEVEL = 25;
export const MAX_SKILL_NODES_PER_RUN = 12;
export const SKILL_PICK_CHOICES = 3;
export const KILL_STREAK_BONUS_PER = 0.05;
export const TIME_XP_INTERVAL_S = 15;
export const TIME_XP_AMOUNT = 2;
export const SALVAGE_XP_DIVISOR = 3;
export const LEVEL_UP_INVULN_S = 0.5;
